import React, { useState } from 'react';
import { API_BASE_URL } from '../../../config/api';
import Navbar from '../../../components/Navbar';
import Footer from '../components/Footer';
import { footerContent, services } from '../content';
import './ContactUs.css';
import '../../../components/Container.css';

const navbarLinks = [
  { href: '/#about', label: 'About' },
  {
    href: '/#services',
    label: 'Services',
    children: services.map((service) => ({ href: `/#${service.id}`, label: service.title })),
  },
  { href: '/#process', label: 'How We Work' },
  { to: '/platform', label: 'Platform' },
  { to: '/contact', label: 'Contact Us', isButton: true },
];

const footerSections = [
  {
    title: 'Services',
    links: services.map((service) => ({ href: `/#${service.id}`, label: service.title })),
  },
  {
    title: 'Company',
    links: [
      { href: '/#services', label: 'Services' },
      { href: '/#process', label: 'How We Work' },
    ],
  },
  {
    title: 'Connect',
    links: [
      { to: '/contact', label: 'Contact Us' },
    ],
  },
];

interface FormData {
  name: string;
  email: string;
  company?: string;
  subject: string;
  message: string;
}

const ContactUs: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    company: '',
    subject: '',
    message: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear errors when user starts typing
    if (error) setError('');
    if (success) setSuccess(false);
  };

  const validateForm = (): boolean => {
    if (!formData.name.trim()) {
      setError('Please enter your name');
      return false;
    }
    if (!formData.email.trim()) {
      setError('Please enter your email address');
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setError('Please enter a valid email address');
      return false;
    }
    if (!formData.subject.trim()) {
      setError('Please enter a subject');
      return false;
    }
    if (!formData.message.trim()) {
      setError('Please enter your message');
      return false;
    }
    if (formData.message.trim().length < 10) {
      setError('Message must be at least 10 characters long');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/contact/submit/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.error || errorData.details || 'Failed to send message'
        );
      }

      const data = await response.json();
      setSuccess(true);
      setFormData({
        name: '',
        email: '',
        company: '',
        subject: '',
        message: '',
      });
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : 'Failed to send message. Please try again later.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="consulting-app">
      <Navbar
        logo={{ src: '/orca-logo.png', text: 'Orca Labs' }}
        links={navbarLinks}
      />

      <main className="contact-main">
        <div className="contact-hero">
          <div className="container">
            <h1 className="contact-title">Get in Touch</h1>
            <p className="contact-subtitle">
              Have a question or want to discuss AI and data for your Retail or CPG business?
              We'd love to hear from you.
            </p>
          </div>
        </div>

        <section className="contact-section">
          <div className="container">
            <div className="contact-content">
              <div className="contact-info">
                <h2>Let's Start a Conversation</h2>
                <p>
                  Whether you're looking to ship applied AI, build the data
                  foundations behind it, or connect models into Retail and CPG
                  operations, we're here to help.
                </p>
                <div className="contact-details">
                  <div className="contact-detail-item">
                    <div className="contact-icon">📧</div>
                    <div>
                      <h4>Email</h4>
                      <a href="mailto:contact@orca-labs.ai">contact@orca-labs.ai</a>
                    </div>
                  </div>
                  <div className="contact-detail-item">
                    <div className="contact-icon">⏱️</div>
                    <div>
                      <h4>Response Time</h4>
                      <p>We typically respond within 24 hours</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="contact-form-container">
                <form onSubmit={handleSubmit} className="contact-form">
                  {error && <div className="error-message">{error}</div>}
                  {success && (
                    <div className="success-message">
                      Thank you for your message! We'll get back to you soon.
                    </div>
                  )}

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">
                        Name <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Your full name"
                        disabled={loading}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="email">
                        Email <span className="required">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="your.email@example.com"
                        disabled={loading}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="company">Company (Optional)</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      placeholder="Your company name"
                      disabled={loading}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">
                      Subject <span className="required">*</span>
                    </label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      disabled={loading}
                    >
                      <option value="">Select a subject</option>
                      <option value="general">General Inquiry</option>
                      <option value="data-foundations">Data Foundations</option>
                      <option value="integrations">Integrations</option>
                      <option value="applied-ai">Applied AI</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">
                      Message <span className="required">*</span>
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows={6}
                      placeholder="Tell us about your project or question..."
                      disabled={loading}
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn-primary btn-large btn-full"
                    disabled={loading}
                  >
                    {loading ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              </div> */}
            </div>
          </div>
        </section>
      </main>

      <Footer
        logo={{ src: '/orca-logo.png', text: 'Orca Labs' }}
        tagline={footerContent.tagline}
        copyright={footerContent.copyright}
        sections={footerSections}
      />
    </div>
  );
};

export default ContactUs;

